export default __webpack_public_path__ + "static/media/Belt of the Rippling Lake.4116ab2f.jpg";